var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgISearch = function SvgISearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3563 2.28848C10.3051 -0.7625 5.33907 -0.7625 2.28789 2.28848C-0.762629 5.34011 -0.762629 10.3051 2.28789 13.3568C5.00504 16.0731 9.23688 16.3641 12.2861 14.243C12.3502 14.5466 12.4971 14.8363 12.7332 15.0724L17.1767 19.5156C17.8242 20.1618 18.8706 20.1618 19.5148 19.5156C20.1617 18.8688 20.1617 17.8225 19.5148 17.1776L15.0714 12.7331C14.8365 12.499 14.5462 12.3515 14.2426 12.2873C16.3651 9.23767 16.0741 5.00678 13.3563 2.28848ZM11.9534 11.954C9.6754 14.2318 5.96809 14.2318 3.69078 11.954C1.41414 9.67616 1.41414 5.96975 3.69078 3.69194C5.96809 1.41478 9.6754 1.41478 11.9534 3.69194C14.2313 5.96975 14.2313 9.67616 11.9534 11.954Z",
    fill: "#0A1A5C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgISearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-search.2044241e.svg";
export { ForwardRef as ReactComponent };